import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment.prod';

@Injectable({
  providedIn: 'root'
})
export class HomeImageService {

  constructor(private _HttpClient:HttpClient) { }
  CreateOrUpdateImage(data:any):Observable<any>{
    return this._HttpClient.post(`${environment.Server_URL}/Lookups/CreateOrUpdateImage`,data);
  }
  GetWebImageList():Observable<any>{
    return this._HttpClient.get(`${environment.Server_URL}/Lookups/GetWebImageList`);
  }
}
